export const UPLOAD_TYPE = {
  officialGuide: "officialGuide",
};
